import { SelectUi } from "../../ui/SelectUi";
import useSWR from "swr";
import { PATH_SEGURIDAD } from "../../../constants/routes";

export const PerfilesSelect = ({ ...props }) => {
  const { data, isLoading } = useSWR(PATH_SEGURIDAD.perfiles);
  const datos = data?.map((row) => ({
    value: row?.id,
    label: row?.nombre,
    accesosgrupo: row?.accesosgrupo,
  }));
  return (
    <SelectUi data={datos} loading={isLoading} mode="multiple" {...props} />
  );
};
